import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn } from "react-icons/fa";
import Logo from "../../assets/audio/images/kwtlogo3.png";

const socialLinks = [
  { href: "https://www.facebook.com/KhadijaWelfareTrust", icon: FaFacebookF, label: "Facebook" },
  { href: "https://www.instagram.com/khadijatulkubrawelfare", icon: FaInstagram, label: "Instagram" },
  { href: "https://www.youtube.com/@khadijawelfareofficial", icon: FaYoutube, label: "YouTube" },
  { href: "https://www.linkedin.com/company/khadija-tul-kubra-welfare-trust", icon: FaLinkedinIn, label: "LinkedIn" },
];

// CustomFooter.jsx
// Standalone responsive footer component with its own styles (no external CSS required).
// - Full width
// - Dark black text (#0b0b0b)
// - Donate button and "Website by Codevente" link
// - Simple newsletter form (no external service)

export default function CustomFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="custom-footer">
      {/* Inline CSS to avoid conflicts with existing styles in your project */}
      <style>{`
        .custom-footer { width: 100%; background: #011a4c; color: #ffffff; font-family: Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial; }
        .cf-inner { max-width: 1200px; margin: 0 auto; padding: 48px 20px; display: grid; grid-template-columns: repeat(4, 1fr); gap: 28px;  }
        .cf-about img { max-height: 80px; display: block; margin-bottom: 12px;background-color: #ffffff; padding: 8px; border-radius: 8px; }
        .cf-about p { margin: 0 0 12px; line-height: 1.6; color: #ffffff; font-size: 14px; }
        .cf-links h4, .cf-newsletter h4 { margin: 0 0 12px; font-size: 20px; text-decoration: underline; color: #fff; }
        .cf-links ul { list-style: none; padding: 0; margin: 0; }
        .cf-links ul li { margin-bottom: 10px; }
        .cf-links a { color: #ffffff; text-decoration: none; font-size: 14px; }
        .cf-links a:hover { color: #fff; }
        .cf-contact li { margin-bottom: 8px; font-size: 14px; }

        .cf-newsletter p { margin: 0 0 8px; color: #ffffff; font-size: 14px; }
        .cf-newsletter form { display: flex; gap: 10px; margin-top: 8px; }
        .cf-newsletter input[type="email"] { flex: 1; padding: 10px 12px; border: 1px solid #e6e6e6; border-radius: 8px; font-size: 14px; }
        .btn { display: inline-flex; align-items: center; justify-content: center; padding: 10px 16px; border-radius: 8px; border: 0; cursor: pointer; font-weight: 600; }
        .btn-primary { background: #000000; color: #fff; }
        .btn-primary:hover { background: #000000; }
        .btn-donate { background: #ff4500; color: #fff; margin-top: 12px; }
        .btn-outline { background: transparent; border: 1px solid #000000; color: #000000; }

        .cf-social { margin-top: 16px; display: flex; gap: 12px; flex-wrap: wrap; }
        .cf-social a { width: 40px; height: 40px; display: inline-flex; align-items: center; justify-content: center; border-radius: 50%; background: rgba(255,255,255,0.15); color: #fff; text-decoration: none; transition: background 0.3s, transform 0.2s; }
        .cf-social a:hover { background: rgba(255,255,255,0.3); color: #fff; transform: translateY(-2px); }
        .cf-social a svg { width: 20px; height: 20px; }
        .cf-social-title { font-size: 16px; font-weight: 600; margin-bottom: 10px; color: #fff; }

        .cf-bottom { border-top: 1px solid rgba(0,0,0,0.06); padding: 18px 20px; text-align:center; justify-content: center; }
        .cf-bottom-inner { max-width: 1200px; margin: 0 auto; display: flex; justify-content: center; gap: 12px; align-items: center; flex-wrap: wrap; }
        .cf-credit a { color: #fff; font-weight: 700; text-decoration: none; }
        

        @media (max-width: 991px) {
          .cf-inner { grid-template-columns: repeat(2, 1fr); }
        }
        @media (max-width: 575px) {
          .cf-inner { grid-template-columns: 1fr; padding: 32px 16px; }
          .cf-newsletter form { flex-direction: column; }
          .cf-newsletter input[type="email"] { width: 100%; }
          .cf-bottom-inner { flex-direction: column; text-align: center; gap: 8px; }
        }
      `}</style>

      <div className="cf-inner">
        {/* ABOUT */}
        <div className="cf-about">
          <Link to="/" onClick={() => window.scrollTo(0, 0)} aria-label="Go to homepage">
            <img src={Logo} alt="Khadija-tul-Kubra Welfare Trust" />
          </Link>
          <p>
            Khadija-tul-Kubra Welfare Trust is a non-profit relief & development organization based in Karachi, Pakistan —
            working to alleviate suffering and help vulnerable families become self-sufficient.
          </p>

          <div className="cf-social-title">Follow Us</div>
          <div className="cf-social">
            {socialLinks.map(({ href, icon: Icon, label }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
                <Icon />
              </a>
            ))}
          </div>
        </div>

        {/* PROGRAMS LINKS */}
        <div className="cf-links">
          <h4>Programs</h4>
          <ul>
            <li><Link to="/releif-activity-pakistan" onClick={() => window.scrollTo(0, 0)}>Emergency Relief</Link></li>
            <li><Link to="/self-sufficiency-plans" onClick={() => window.scrollTo(0, 0)}>Self-Sufficiency Plans</Link></li>
            <li><Link to="/quranic-institutes-network" onClick={() => window.scrollTo(0, 0)}>Quranic Institutes</Link></li>
            <li><Link to="/food-supply" onClick={() => window.scrollTo(0, 0)}>Food Distribution</Link></li>
            <li><Link to="/water-supply" onClick={() => window.scrollTo(0, 0)}>Water Supply</Link></li>
          </ul>
        </div>

        {/* QUICK LINKS */}
        <div className="cf-links">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/about" onClick={() => window.scrollTo(0, 0)}>About Us</Link></li>
            <li><Link to="/education" onClick={() => window.scrollTo(0, 0)}>Education</Link></li>
            <li><Link to="/orphans-support" onClick={() => window.scrollTo(0, 0)}>Orphans Support</Link></li>
            <li><Link to="/login" onClick={() => window.scrollTo(0, 0)}>Login</Link></li>
            <li><Link to="/donate" onClick={() => window.scrollTo(0, 0)}>Donate</Link></li>
          </ul>
        </div>

        {/* NEWSLETTER + DONATE */}
        <div className="cf-newsletter">
          <h4>Stay Updated</h4>
          <p>Subscribe for news and event updates. We only send important messages.</p>

          <form onSubmit={(e) => { e.preventDefault(); const email = e.target.email.value; if (!email) { alert('Please enter your email'); return; } console.log('subscribe:', email); e.target.reset(); alert('Thanks for subscribing!'); }}>
            <input name="email" type="email" placeholder="Your email address" aria-label="Email address" />
            <button type="submit" className="btn btn-primary">Subscribe</button>
          </form>

          <div>
            <button className="btn btn-donate" onClick={() => window.location.href = '/donate'} aria-label="Donate now">Donate Now</button>
          </div>
        </div>
      </div>

      <div className="cf-bottom" >
        <div className="cf-bottom-inner">
          <div>© {year} Khadija-tul-Kubra Welfare Trust. All rights reserved.</div>
          <div className="cf-credit">Website by <a href="https://codevente.com" target="_blank" rel="noopener noreferrer">Codevente</a></div>
        </div>
      </div>
    </footer>
  );
}
